export const downloadFile = (targetURL) => {
  const aLink = document.createElement("a");
  aLink.href = targetURL;
  aLink.download = "pdf";
  aLink.click();
};
